import { render, staticRenderFns } from "./slides.vue?vue&type=template&id=0fc98698&scoped=true"
import script from "./slides.vue?vue&type=script&lang=js"
export * from "./slides.vue?vue&type=script&lang=js"
import style0 from "./slides.vue?vue&type=style&index=0&id=0fc98698&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc98698",
  null
  
)

export default component.exports